export const MAX_PROFILE_IMAGE_SIZE_BYTES = 10 * 1024 * 1024; // 10 MB

export const PROFILE_IMAGE_ACCEPT = '.jpg,.jpeg,.png,.svg,image/jpeg,image/png,image/svg+xml';

const ACCEPTED_MIME_TYPES = new Set(['image/jpeg', 'image/jpg', 'image/png', 'image/svg+xml']);
const ACCEPTED_EXTENSIONS = new Set(['.jpg', '.jpeg', '.png', '.svg']);

const getFileExtension = (fileName) => {
  const name = String(fileName || '').toLowerCase();
  const dotIndex = name.lastIndexOf('.');
  if (dotIndex < 0) return '';
  return name.slice(dotIndex);
};

/** Returns an error message when invalid, otherwise `null`. */
export const getProfileImageValidationError = (file) => {
  if (!file) return 'Please select an image';

  const mimeType = String(file.type || '').toLowerCase();
  const extension = getFileExtension(file.name);
  const typeAllowed = ACCEPTED_MIME_TYPES.has(mimeType);
  const extensionAllowed = ACCEPTED_EXTENSIONS.has(extension);

  if (!typeAllowed && !extensionAllowed) {
    return 'Only JPG, JPEG, PNG, or SVG files are supported';
  }

  if (file.size > MAX_PROFILE_IMAGE_SIZE_BYTES) {
    return 'Image size must be 10 MB or less';
  }

  return null;
};
